import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function inscripcionReducer(state= initialState.inscripcion, action){
    let newState;
	switch(action.type){
         case types.LOAD_INSCRIPCION_LIST_SUCCESS:		
            /*
            action.inscripcion.filtroActivo=state.filtroActivo;
            action.inscripcion.filtroActual=state.filtroActual;
            action.inscripcion.showActivos=state.showActivos;
			 action.inscripcion.paginaActual=action.inscripcion.pageable.pageNumber;
			 action.inscripcion.registrosPorPagina=action.inscripcion.size;
            */
            return action.inscripcion;

        case types.BORRAR_INSCRIPCION_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(inscripcion => inscripcion.id !== action.inscripcion.id)];          
			return newState;    
            
        case types.ACTIVAR_INSCRIPCION_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(inscripcion => inscripcion.id !== action.inscripcion.id)];          
			 return newState;
            
        case types.SET_FILTRO_INSCRIPCION:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
            
        case types.CONSTANCIA_INSCRIPCION_SUCCESS:
            
            newState=Object.assign({}, state);
            let index = newState.inscripcion.findIndex(a=>a.id==action.inscripcion.id);    
            newState.inscripcion[index].finalizado = action.inscripcion.finalizado;
        
            
            return newState;
            
		break;
            
		default:
			return state;
	}
}